import { render } from "./search-results.vue?vue&type=template&id=50fb8766"
import script from "./search-results.vue?vue&type=script&lang=js"
export * from "./search-results.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__